<template>
  <section id="getMiao">
    <div class="top">
      <img src="@/assets/images/miao/back.png" alt="" @click='closePage'>
      <p>如何获得喵喵？</p>
      <span></span>
    </div>
    <ul class="list">
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/like.png" alt="">
          <div>
            <h2>“喜欢主播”得喵喵</h2>
            <p>点击直播间视频位置出现小心心，持续点击几率获得喵喵</p>
          </div>
        </div>
        <div class="like_right">
          <p class="everyday">每日{{click_mic_get.get_num}}/{{click_mic_get.get_limit}}</p>
        </div>
      </li>
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/tv.png" alt="">
          <div>
            <h2>看直播得喵喵</h2>
            <p>每看10分钟直播，可得1只喵喵</p>
          </div>
        </div>
        <div class="like_right">
          <p class="everyday">每日{{view_mic_get.get_num}}/{{view_mic_get.get_limit}}</p>
          <p class="time" v-show='viewBol'>{{minute}}:{{second}}后可得</p>
        </div>
      </li>
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/tiger.png" alt="">
          <div>
            <h2>玩“喵喵雨”得喵喵</h2>
            <p>2.4日起，每晚9点起，各开播直播间触发新年喵喵雨；除夕当天，下午3点起，每3小时，各开播直播间触发新年喵喵雨</p>
          </div>
        </div>
        <div class="like_right">
        </div>
      </li>
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/message.png" alt="">
          <div>
            <h2>跟朋友要喵</h2>
            <p>请求朋友赐喵，可得喵喵</p>
          </div>
        </div>
        <div class="like_right">
          <button class="btnOn" @click='toGetMiao("0")'>去讨要</button>
        </div>
      </li>
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/wallet.png" alt="">
          <div>
            <h2>充值得喵喵</h2>
            <p>每充值￥20元，可得1只喵喵</p>
          </div>
        </div>
        <div class="like_right">
          <p class="everyday">每日{{recharge_get.get_num}}/{{recharge_get.get_limit}}</p>
          <button :class="recharge_get.button_status == 2 ? 'btnOff' : 'btnOn'" @click='toGetMiao("1", recharge_get.button_status)'>{{rechargeBtnText[recharge_get.button_status]}}</button>
        </div>
      </li>
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/packet.png" alt="">
          <div>
            <h2>送礼得喵喵</h2>
            <p>开播直播间，每赠送3个“太平乐”礼物，可得1只喵喵</p>
          </div>
        </div>
        <div class="like_right">
          <p class="everyday">每日{{send_gift_get.get_num}}/{{send_gift_get.get_limit}}</p>
          <button class="btnOn" @click='toGetMiao("2")'>去赠送</button>
        </div>
      </li>
      <li class="like">
        <div class="like_left">
          <img src="@/assets/images/miao/phone.png" alt="">
          <div>
            <h2>绑手机号得喵喵</h2>
            <p>绑定手机号后，可领取5只喵喵</p>
          </div>
        </div>
        <div class="like_right">
          <button :class="bind_get.button_status == 2 ? 'btnOff' : 'btnOn'" @click='toGetMiao("3", bind_get.button_status)'>{{bindBtnText[bind_get.button_status]}}</button>
        </div>
      </li>
    </ul>
    <!-- 收下喵喵.领取按钮弹出 -->
    <div class="obtainMiao" v-if='obtainBol'>
      <div class="mock"></div>
      <div class="main">
        <img :src="cover_url" alt="">
        <div @click='obtainMiaoHide'>收下</div>
      </div>
    </div>
    <!-- swiper -->
    <div class="swiper_box" v-if='swiperBoxBol'>
      <div class="mock"></div>
      <div class="get_miao_title" v-if='miaoSwiperImgList.length>1'>恭喜获得<span>{{miaoSwiperImgList.length}}</span>只基础喵</div>
      <div class="recommendPage">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for='(item, index) in miaoSwiperImgList' :key='index'>
            <img :src="item.cover_url" alt="">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="take" @click='swiperBoxBolFalse'>
          收下
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@/assets/style/swiper.css";
import "@/assets/style/awardSwiper.css";
import { get } from '@/http'
import api from '@/http/api'
export default {
  name : "getMiao",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      click_mic_get: {
        get_limit: 3,
        get_num:0
      },
      view_mic_get: {
        get_limit: 3,
        get_num:0
      },
      recharge_get: {
        get_limit: 3,
        get_num:0,
        button_status: 0
      },
      send_gift_get: {
        get_limit: 3,
        get_num:0
      },
      bind_get: {
        button_status: 0
      },
      minutes: '', // 分
      seconds: '', // 秒
      viewBol: false, // 观看直播倒计时
      obtainBol: false, // 喵喵奖励弹窗
      rechargeBtnText: {
        0: '去充值',
        1: '领取',
        2: '已领取'
      },
      bindBtnText: {
        0: '去绑定',
        1: '领取',
        2: '已领取'
      },
      cover_url: '', // 礼物图片
      swiperBoxBol: false,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination" //允许分页点击跳转
        },
      },
      miaoSwiperImgList: [],
    }
  },
  created () {
  },
  mounted () {
    document.title = '喵喵'
    let that = this
    setTimeout(() => {
      console.log(window.winOcx)
      console.log(window.winOcx.getUserData, 'getUserData')
      if (window.winOcx.getUserData) {
        console.log('123123132132132132')
        window.winOcx.getUserData(function(data){
          console.log(data, '数据')
          sessionStorage.setItem('initData', JSON.stringify(data))
          that.getUserTasksHttp()
        })
        window.winOcx.resetBackground()
      } else {
        console.log('没有拿到getUserData方法')
      }
    }, 1000);
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal)
      }
    },
    minute: {
      handler(newVal) {
        this.num(newVal)
      }
    }
  },
  computed: {
    second: function () {
      return this.num(this.seconds)
    },
    minute: function () {
      return this.num(this.minutes)
    }
  },
  methods: {
    getUserTasksHttp () {
      let initData = JSON.parse(sessionStorage.getItem('initData'))
      get(api.getUserTasks, '&rid='+initData.roomID).then(res => {
        if (res.code == 200) {
          // click_mic_get 喜欢主播获得喵
          // view_mic_get 直播任务
          // recharge_get 充值任务
          // send_gift_get 赠送红包
          // bind_get 绑定任务
          let tasks = res.data.tasks
          Object.keys(tasks).map((item, index) => {
            this[item] = Object.values(tasks)[index]
          })
          let { get_limit, get_num, diff_time } = tasks.view_mic_get
          if ( get_limit == get_num || diff_time == 0) {
            this.viewBol = false
          } else {
            // 倒计时
            this.viewBol = true
            // diff_time = 5
            this.timeGo(diff_time)
          }
        }
      })
    },
    // 获取充值奖励
    getRechargeAwardHttp () {
      get(api.getRechargeAward).then(res=> {
        if (res.code == 200) {
          this.miaoSwiperImgList = res.data
          this.swiperBoxBol = true
          // 领取之后重新掉下任务接口
          this.getUserTasksHttp()
        }
      })
    },
    getBindPhoneAwardHttp () {
      get(api.getBindPhoneAward).then(res=> {
        if (res.code == 200) {
          this.miaoSwiperImgList = res.data
          this.swiperBoxBol = true
          // 领取之后重新掉下任务接口
          this.getUserTasksHttp()
        }
      })
    },
    // 关闭礼物弹窗
    obtainMiaoHide () {
      this.obtainBol = false
    },
    // 按钮点击
    toGetMiao (num, status) {
      switch (num) {
        case '0' :
          // 去讨要 跳转到活动详情页
          window.winOcx.closePage()
          window.winOcx.openJiMiaoView()
        break;
        case '1' :
          // 去充值 跳到充值页面领取,已领取
          // 判断status
          if (status == 0) {
            // 去充值
            window.winOcx.goQuicklyPay()
          } else if (status ==1) {
            // 领取
            this.getRechargeAwardHttp()
          }
        break;
        case '2' :
          // 去赠送 打开赠送礼物弹窗并关闭当前h5弹窗
          // 关闭弹窗
          window.winOcx.openLiveGift()
          window.winOcx.closePage()
        break;
        case '3' :
          // 去绑定 绑定手机号或领取,已领取
          // 0去绑定
          if (status == 0) {
            let initData = JSON.parse(sessionStorage.getItem('initData'))
            if (initData.os == 2) {
              window.winOcx.closePage()
            }
            window.winOcx.bindMobile()
          } else if (status == 1) {
            // 领取 调用接口展示领取弹窗
            this.getBindPhoneAwardHttp()
          }
        break;
      }
    },
    num (n) {
      return n < 10 ? '0' + n : '' + n
    },
    add() {
      let _this = this;
      let time = setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          clearInterval(time)
          // 更新任务列表
          _this.getUserTasksHttp()
        } else {
          _this.seconds -= 1
        }
      }, 1000)
    },
    timeGo (time) {
      let mm = Math.floor(time / 60);
      let ss = time - mm * 60;
      this.seconds = ss;
      this.minutes = mm
      this.add()
    },
    closePage () {
      window.winOcx.closePage()
    },
    swiperBoxBolFalse () {
      this.swiperBoxBol = false
    }
  }
}
</script>
<style lang="scss" scoped>
  @mixin font($size, $color){
    color: $color;
    font-size: $size
  }
  #getMiao{
    width: 100%;
    background: #FFD6A7;
    border-radius: 16px 16px 0px 0px;
    padding: 0 32px 50px 32px;
    box-sizing: border-box;
    // overflow-y: scroll;
    position: relative;
    .get_miao_title{
      text-align: center;
      font-size: 34px;
      color: #FEDCB4;
      position: fixed;
      top: 20px;
      left: 0;
      right: 0;
      z-index: 1;
      font-weight: 500;
      span{
        font-size: 52px;
        margin: 0 8px;
      }
    }
    .mock{
      height: 1258px !important;
    }
    .recommendPage{
      top: 100px !important
    }
    .top{
      display: flex;
      justify-content: space-between;
      padding-top: 34px;
      // position: absolute;
      // top: 0;
      // left: 0;
      // width: 100%;
      // background: #FFD6A7;
      span,img{
        width: 32px;
        height: 32px;
      }
      p{
        @include font(34px, #994A0B);
        font-weight: 600;
        line-height: 34px;
      }
    }
    .list{
      li{
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
        background-image: url('../../assets/images/miao/bg_big.png');
        background-size: 100% 100%;
        padding-bottom: 20px;
        &:nth-child(3) {
          .like_right{
            width: 80px;
          }
        }
      }
      .like_left{
        display: flex;
        justify-content: space-between;
        flex: 1;
        margin: 20px 0 0 20px;
        img{
          width: 80px;
          height: 80px;
        }
        div{
          flex: 1;
          margin-left: 16px;
        }
        h2{
          @include font(30px, #994A0B);
          line-height: 42px;
        }
        p{
          @include font(22px, #C45700);
          line-height: 32px;
          margin-top: 6px;
        }
      }
      .like_right{
        width: 140px;
        margin-right: 20px;
        position: relative;
        .everyday{
          margin-top: 20px;
          @include font(22px, #C45700);
          text-align: right;
          line-height: 28px;
        }
        .time{
          @include font(20px, #C45700);
          margin-top: 20px;
          line-height: 32px;
          text-align: right;
        }
        button{
          width: 116px;
          height: 44px;
          border: none;
          @include font(22px, #FFD18D);
          background: transparent;
          line-height: 15px;
          font-weight: 600;
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .btnOn{
          background-image: url('../../assets/images/miao/bg_2.png');
          background-size: 100% 100%;
        }
        .btnOff{
          background-image: url('../../assets/images/miao/juxingno.png');
          background-size: 100% 100%;
          color: #fff;
        }
      }
    }
    .mock{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: .5;
    }
    .obtainMiao{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      .main{
        position: absolute;
        left: 50%;
        top: 50vh;
        width: 504px;
        height: 628px;
        transform: translate(-50%, -50%);
        div{
          width: 282px;
          height: 76px;
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translate(-50%, 0);
          background: url('../../assets/images/miao/juxingyes.png') no-repeat;
          background-size: 100% 100%;
          line-height: 76px;
          text-align: center;
          color: #FB2418;
          font-size: 32px;
          font-weight: 500;
        }
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
